import { render } from "./PriceGroup.vue?vue&type=template&id=6fe488f1&ts=true"
import script from "./PriceGroup.vue?vue&type=script&lang=ts"
export * from "./PriceGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__